import { getPreferredProp } from "../../utils";
function isAddressValid() {
  let {
    state,
    city,
    required
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const stateValue = getPreferredProp(state, 'value');
  const cityValue = getPreferredProp(city, 'value');
  const isEmpty = !stateValue;
  const hasEnoughInfo = !!cityValue;
  return hasEnoughInfo || isEmpty && !required;
}
export default isAddressValid;
//# sourceMappingURL=isAddressValid.js.map